import React from "react";
import PropTypes from "prop-types";

import CommonsConstants from "../configurations/Constants";

import Svg from "../../../svg/Svg";


export default class TeaserIcon extends React.Component {

    static propTypes = {
        style           : PropTypes.string,
        className       : PropTypes.string
    };

    render = () => {
        let svgIcon =
            this.props.style === CommonsConstants.POST_STYLES.EVENT ?  "fa-calendar" :
            this.props.style === CommonsConstants.POST_STYLES.PICTURE_GALLERY ? "fa-camera" :
            this.props.style === CommonsConstants.POST_STYLES.VIDEO ? "watermark-video" :
            this.props.style === CommonsConstants.POST_STYLES.DOSSIER ? "watermark-dossier" :
            this.props.style === CommonsConstants.POST_STYLES.DATA ? "watermark-data" :
            this.props.style === CommonsConstants.POST_STYLES.AUDIO ? "watermark-podcast" :
            this.props.style === CommonsConstants.POST_STYLES.TICKER ? "watermark-ticker" :
            this.props.style === CommonsConstants.POST_STYLES.CAMPAIGN ? "" :
            this.props.style === CommonsConstants.POST_STYLES.POLL ? "watermark-poll" :
            this.props.style === CommonsConstants.POST_STYLES.STORY_TELLING ? "watermark-storyTelling": "";

        return (
            this.props.style !== "" ?
                <Svg id={svgIcon} className={this.props.className}/> : null
        );
    }
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/TeaserIcon.jsx